import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import Card from "components/ui/Card/Card";
import Icon from "components/ui/Icon/Icon";
import SettingsGrid from "pages/home/components/SettingsGrid";
import { useAuth } from "context/AuthContext";
import { elevatedPumpRechargeRoles, normalizeRoleName, RoleName } from "constants/roles";
import styles from "./SettingsPage.module.scss";

function SettingsPage() {
  const { user } = useAuth();
  const normalizedRoles = useMemo(
    () =>
      (user?.roles ?? [])
        .map((role) => normalizeRoleName(role.roleName))
        .filter((roleName): roleName is RoleName => Boolean(roleName)),
    [user]
  );
  const canAccessPumpRecharge = normalizedRoles.some((role) =>
    elevatedPumpRechargeRoles.includes(role)
  );
  const isSuperAdmin = normalizedRoles.includes(RoleName.SUPER_ADMIN);

  return (
    <div className={styles.page}>
      <SettingsGrid />
      {canAccessPumpRecharge && (
        <Card className={styles.actionCard}>
          <div className={styles.actionContent}>
            <div>
              <p className={styles.actionLabel}>Pump Recharge</p>
              <p className={styles.actionHint}>
                Raise top-up requests or review approvals for assigned pumps.
              </p>
            </div>
            <NavLink to="/settings/pump-recharge" className={styles.actionLink}>
              <span>Open</span>
              <Icon name="arrowRight" className={styles.actionLinkIcon} />
            </NavLink>
          </div>
        </Card>
      )}
      {isSuperAdmin && (
        <Card className={styles.actionCard}>
          <div className={styles.actionContent}>
            <div>
              <p className={styles.actionLabel}>Device Logs</p>
              <p className={styles.actionHint}>
                Monitor ATM device activity, payloads, and request metadata.
              </p>
            </div>
            <NavLink to="/settings/device-logs" className={styles.actionLink}>
              <span>Open</span>
              <Icon name="arrowRight" className={styles.actionLinkIcon} />
            </NavLink>
          </div>
        </Card>
      )}
    </div>
  );
}

export default SettingsPage;
